import { fontType } from "../../../assets/extras"

const RecordCard = ({
    data,
    delay,
    onHandlePress,
    onDeleteReg
}) => {
    return (
        <div
            style={{
                position: "relative", // 🔑 necesario para posicionar el tache
                borderColor: "black",
                borderWidth: "2px",
                borderStyle: "solid",
                borderRadius: "10px",
                width: "90%",
                maxWidth: 700,
                marginTop: "10px",
                marginBottom: "5px",
                padding: "10px",
                backgroundColor: "white",
                paddingTop: 40
            }}
        >
            {/* Tache */}
            <button
                style={{
                    position: "absolute",
                    top: "8px",
                    right: "10px",
                    border: "none",
                    background: "transparent",
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "red",
                    cursor: "pointer"
                }}
                onClick={() => onDeleteReg(data, delay)}
            >
                ✕
            </button>

            <div
                style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                    fontFamily: fontType.title,
                cursor: "pointer",
                }}
                onClick={() => onHandlePress(data)}
            >
                {data.nombre_clase}
            </div>

            <div style={{ marginTop: "10px",
                cursor: "pointer", }}
                onClick={() => onHandlePress(data)}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "15px",
                        fontStyle: "italic",
                        fontFamily: fontType.text
                    }}
                >
                    {data.fecha_clase} | {data.hora_clase}
                </div>
            </div>

            <div style={{ marginTop: "25px" }}>
                <div style={{ fontSize: "16px" }}>{/* subtitle */}</div>
            </div>
        </div>

    )
}

export default RecordCard